export interface StatusReason {
  title: string;
  statusCode: string;
  statusDescriptionFDA: string;
  statusDescriptionDotcomUI: string;
  priority: string;
  color: string;
  errorType: string;
}

export interface TravelDocsErrors {
  [key: string]: StatusReason;
}

export interface RequirementsRequest {
  using: string;
  confirmationNum: string;
  givenNames: string;
  surname: string;
}

export interface TravelDocumentImport {
  buttonType: string;
  requirementType: string;
  formName: string;
  countryCode?: string;
}

export interface TripDetailsToRequirements {
  request: RequirementsRequest;
  formDetails?: TravelDocumentImport;
}
